import { useToast, UseToastOptions } from '@chakra-ui/react';

export const useTopRightToast = (options: UseToastOptions = {}): ReturnType<typeof useToast> => {
    return useToast({
        position: 'top-right',
        containerStyle: {
            position: 'absolute',
            top: '50px',
            right: '0',
            ...(options.containerStyle || {}),
        },
        ...options,
    });
};
